module.exports = __webpack_public_path__ + "img/si.011c0004.svg";